/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chip, Grid, IconButton, Paper } from '@material-ui/core'
import Delete from '@material-ui/icons/Delete'
import theme from '../../../theme'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useBudgetStyles } from '../../Budget/styles'
import { useBudgetForm } from '../../Budget/useBudgetForm'
import { BillState, BillStateToText } from '../Subscription/BillCard'

interface IOrderProps {
  order: any
  onDelete: () => void
}

const OrderCard = ({ order, onDelete }: IOrderProps): JSX.Element => {
  const classes = useBudgetStyles()
  const history = useHistory()
  const { set } = useBudgetForm()

  const handleSelect = () => {
    set({
      id: order.id,
      numberOs: order.numberOs,
      discount: order.payment.discount,
      items: order.cart.map((i: any) => ({
        ...i,
        price: {
          float: i.price
        }
      })),
      iols: {
        ...order.iol,
        name: order.iol.iolName,
        iolType: order.iol.typeId,
        id: order.iol.iolId,
        price: { float: order.iol.price }
      },
      observation: order.annotations,
      patient: { ...order.customer, __typename: undefined }
    })
    history.push('/nav/orcamento')
  }

  return (
    <Paper onClick={handleSelect} elevation={0} className={classes.root}>
      <Grid container justify="space-around" alignItems="center">
        <Grid xs={1} className={classes.value}>
          #{`${order.numberOs}`.padStart(3, '0')}
        </Grid>
        <Grid xs={3} className={classes.name}>
          {order.name}
        </Grid>
        <Grid xs={2} className={classes.value} style={{ textAlign: 'center' }}>
          {order.date}
        </Grid>
        <Grid xs={2} className={classes.value} style={{ textAlign: 'center' }}>
          {order.value.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
          })}
        </Grid>
        <Grid xs={2} style={{ textAlign: 'center' }}>
          <Chip
            style={{
              minWidth: 100,
              backgroundColor: {
                [BillState.Sale]: theme.palette.success.main,
                [BillState.Budge]: theme.palette.warning.main
              }[order.state as BillState],
              color: {
                [BillState.Sale]: theme.palette.success.contrastText,
                [BillState.Budge]: theme.palette.warning.contrastText
              }[order.state as BillState]
            }}
            label={BillStateToText(order.state)}
          />
        </Grid>
        {/* <Grid xs={2} style={{ textAlign: 'right' }}>
          <GetAppIcon className={classes.icon} />
        </Grid> */}
        <Grid xs={2} style={{ textAlign: 'right' }}>
          <IconButton
            onClick={e => {
              e.stopPropagation()
              onDelete()
            }}
          >
            <Delete className={classes.icon} />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default OrderCard
